import React from "react";
import { ElementRoot } from "./ElementRoot.jsx";
import { mediaElementShape } from "./shapes/index.jsx";

export const OtherDocumentPreview = React.forwardRef(({ url }, ref) => {
  return (
    <ElementRoot loaded>
      <span>
        <iframe
          ref={ref}
          className="original"
          src={url}
        />
      </span>
    </ElementRoot>
  );
});

OtherDocumentPreview.propTypes = mediaElementShape;

OtherDocumentPreview.displayName = "OtherDocumentPreview";
